
import { Region } from './types/region-types';
import { fetchJoshuaProjectData } from './utils/joshua-project-api';
import { base_regions } from './mexico/regions';

// Helper function to merge Joshua Project data with base regions
const mergeJoshuaProjectData = async (regions: Region[]): Promise<Region[]> => {
  try {
    const jpData = await fetchJoshuaProjectData();
    
    return regions.map(region => {
      const regionGroups = jpData.filter(group => group.region_id === region.region_id);
      const unreachedPopulation = regionGroups.reduce((sum, group) => sum + group.population, 0);
      
      return {
        ...region,
        unreached_population: unreachedPopulation
      };
    });
  } catch (error) {
    console.error("Error fetching Joshua Project data:", error);
    return regions; // Return original regions if fetch fails
  }
};

// Export the base regions initially
export const regions_mexico: Region[] = base_regions;

// Create a function to load the data that can be called after the app initializes
export const loadRegionData = async (): Promise<void> => {
  try {
    console.log("Loading region data...");
    const enrichedRegions = await mergeJoshuaProjectData(base_regions);
    
    // Update the regions_mexico array with the enriched data
    regions_mexico.length = 0;
    regions_mexico.push(...enrichedRegions);
    console.log("Region data loaded successfully:", regions_mexico.length, "regions");
    console.log("Sample region data:", regions_mexico[0]);
  } catch (error) {
    console.error("Error loading region data:", error);
  }
};
